import { Injectable } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { DataService } from './data.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { Http, RequestOptions, Headers } from '@angular/http';
import { map } from 'rxjs/operators';

@Injectable({
  	providedIn: 'root'
})
export class DebugService {

	constructor(
		private dataSvc: DataService,
		private afs: AngularFirestore,
		private http: Http
	) { }
	  
	// Create an error object without type based on properties of given error.
    // Plus add some other information properties.
    getErrorObject(error: any, code: string, user: any, description: string): any {
        try {
            // Get the string if error has a toString();
            let errorObjToString: string = '';
            if (error.toString && typeof error.toString === 'function')
                errorObjToString = error.toString();

            let outputError: any = {
                appName: 'sign-up',
                code: code,
                schoolAlias: '',
                userAgent: window.navigator.userAgent || '',
                uid: user ? user.uid : '',
                email: user ? user.email : '',
                description: description,
                version: '',
                appType: '',
                createdDate: new Date(),
                errorObj: this.getNonCustomObj(error),
                errorObjToString: errorObjToString
            };

            return outputError;
        }
        catch (err) {
            throw err;
        }
	}

	// Create a new object from the properties of another that has no type.
    // Runs recursively.
    getNonCustomObj(obj: any): any {
        if (isNullOrUndefined(obj))
            return {};

        // Just return back strings, prevent turning them into character list objects.
        if (typeof obj === 'string')
            return obj;

        let newObj: any = {};
        for (let property in obj) {
            if (obj.hasOwnProperty(property)) {
                switch (typeof obj[property]) {
                    case 'function':
                        // Skip these...
                        break;
                    case 'object':
                        // Can include objects, arrays, Date(), regex, null...
                        if (isNullOrUndefined(obj[property]))
                            newObj[property] = '';
                        else {
                            // Recusively call on this new obj property.
                            newObj[property] = this.getNonCustomObj(obj[property]);
                        }

                        break;
                    case 'undefined':
                        // Skip these...
                        break;
                    default:
                        // Other types like number, string, boolean, etc...
                        newObj[property] = obj[property];
                        break;
                }
            }
        }

        return newObj;
	}
	
	    // New function to log improved generic errors to the database.
		async logErrorToDBV2(errorObj: any): Promise<any> {
			try {
				let headers = new Headers({
					'Content-Type': 'application/json',
					'Authorization' : this.dataSvc.getAuthBearerTokenNoUserNoDaycareAlias(this.afs.createId())
				});
				let options = new RequestOptions({ headers: headers });
	
				let body = { log: errorObj };
	
				//let url: string = this.cloudFunctionsSvc.childPilotCloudFunctionsURL + 'addLog';
				let url: string = this.dataSvc.getAPIBaseUrl() + '/addLog';
	
				let response = await this.http.post(url, body, options)
					.pipe(
						map(res => res.json())
					)
					.toPromise();
	
				//console.log(response);
	
				return response;
			}
			catch (err) {
				throw err;
			}
		}
}
